<template>
    <div ng-if="cert" @click="certClick" class="cert" :class="{ disabled: !isValid }" :title="[!isValid ? translate('certificateItem.certificateExpired') : '']" >
        <img src="@/assets/cert.png" style="float:left; padding-right:10px;"/>
        <div>
            <div style="font-weight:bold;">{{cert.Country}} {{cert.Serial}} {{cert.OwnerName}}</div>
            <div>{{cert.Email}}</div>
            <div class="text-muted">
                <small>{{translate('certificateItem.lastValid')}}: {{cert.ValidBefore | date}}</small>
                <span v-if="!isValid" class="badge badge-danger ml-2">{{translate('certificateItem.certInvalid')}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"CertificateItem",
    props: {
        cert: Object,
        loading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        lastValid(){
            return new Date(parseInt(this.cert.ValidBefore, 10));
        },
        isValid(){
            return this.lastValid > new Date()
        }
    },
    methods: {
        certClick($event){
            if(this.isValid && !this.loading)
                this.$emit('click', $event)
        }
    }
}
</script>
<style scoped>
    .cert {
        padding: 10px;
        cursor:pointer;
    }

    .cert:hover {
        background: #f5f5f5;
    } 

    .cert.disabled {
        cursor:not-allowed;
        opacity: 0.8;
    }
</style>